// Keep in sync with requests/fulfillments/fulfillment_type.py
import {assert} from 'Asserts';
import {RequestSchema} from 'requests/RequestConstants';

import {RequestFulfillmentDefinition} from './FulfillmentConstants';

export enum FulfillmentType {
  REQUEST = 'REQUEST',
  SAMPLE_GROUP = 'SAMPLE_GROUP',
  SAMPLE_GROUP_AND_TASK = 'SAMPLE_GROUP_AND_TASK',
}

const TYPE_TO_NAME = {
  [FulfillmentType.REQUEST]: 'request',
  [FulfillmentType.SAMPLE_GROUP]: 'sample',
  [FulfillmentType.SAMPLE_GROUP_AND_TASK]: 'sample',
};

export function requestSchemaToFulfillmentType(requestSchema: RequestSchema): FulfillmentType {
  // The "?" should not be necessary. We include it as a temporary workaround for BNCH-17522,
  // which is a bug we will not be investigating further.
  if (requestSchema?.sampleGroupSchema) {
    return requestSchema.requestTaskSchemaIds.length
      ? FulfillmentType.SAMPLE_GROUP_AND_TASK
      : FulfillmentType.SAMPLE_GROUP;
  }
  return FulfillmentType.REQUEST;
}

export function fulfillmentDefinitionsToType(
  fulfillmentDefinitions: Array<RequestFulfillmentDefinition>
): FulfillmentType {
  assert(fulfillmentDefinitions.length > 0, 'Expected at least one fulfillment');
  // Assume all fulfillments have same type, so use 1st one
  const def = fulfillmentDefinitions[0];
  if (def.requestTaskId) {
    assert(def.sampleGroupId != null, 'sampleGroupId should be set when requestTaskId is set');
    return FulfillmentType.SAMPLE_GROUP_AND_TASK;
  } else if (def.sampleGroupId) {
    return FulfillmentType.SAMPLE_GROUP;
  } else {
    return FulfillmentType.REQUEST;
  }
}

export function fulfillmentTypeToPluralized(type: FulfillmentType): string {
  return `${TYPE_TO_NAME[type]}s`;
}
